export default {"src":"/_next/static/media/bikeAlert_24.6ba4c089.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};